import { render, staticRenderFns } from "./KintaiGetsudoDataView.vue?vue&type=template&id=6f3ef0a2&scoped=true&"
import script from "./KintaiGetsudoDataView.vue?vue&type=script&lang=ts&"
export * from "./KintaiGetsudoDataView.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiGetsudoDataView.vue?vue&type=style&index=0&id=6f3ef0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ef0a2",
  null
  
)

export default component.exports